import { Component, Input, OnDestroy, ElementRef } from '@angular/core';
import { interval } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'img[app-image-swapper]',
    template: ``,
    standalone: false
})
export class ImageSwapperComponent implements OnDestroy {
  @Input() srcSets: string[];

  constructor(private img: ElementRef<HTMLImageElement>) {
    interval(3000)
      .pipe(untilDestroyed(this))
      .subscribe(i => {
        if (img && img.nativeElement) {
          img.nativeElement.srcset = this.srcSets[i % this.srcSets.length];
        }
      });
  }

  ngOnDestroy() {}
}
